module.exports = __webpack_public_path__ + "static/media/S (199).444f835b.jpg";